import { createApp } from "vue";
import clickOutside from "components/jiffy/vue-cart/filters/clickOutside";
import StickersUpsell from "./StickersUpsell.vue";

export const setup = (selector = "#vue-stickers-upsell") => {
  const $wrapper = document.querySelector(selector);
  if (!$wrapper) return;

  const stickersUpsellWrapper = createApp({});
  stickersUpsellWrapper.component("StickersUpsell", StickersUpsell);
  stickersUpsellWrapper.directive("click-outside", clickOutside());
  stickersUpsellWrapper.mount(selector);
};

export default setup;
